module.exports = {"id":"189899","name":"Vito Wormgoor","rating":"72","photo":"./data/images/photos/4/189899.png","club":{"name":"SK Brann","logo":"./data/images/clubs/SKBrann.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VitoWormgoor0.json
// module id = 4290
// module chunks = 0